import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.slice";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/data/landun/workspace/codebase/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Avatar from '@vip-activity/ui/components/Avatar/Avatar.vue';
import Storage from '@tencent/vft-common/Storage';
import { setUrlParam } from '@tencent/vft-common/util';
import MagicService from '@/service/magic';
import BuyPop from '../Pop/BuyPop/BuyPop.vue';
import Kill from '../Kill/Kill.vue'; // import { removeHttp } from '../../util/helper'

var KEY = 'vftYSFShowReceiveHistoryTime';
export default {
  components: {
    BuyPop: BuyPop,
    Avatar: Avatar,
    Kill: Kill
  },
  data: function data() {
    return {
      showHistoryTime: Storage.get(KEY),
      actorIndex: -1
    };
  },
  computed: {
    // 是否预约，从store中获取
    hasBook: function hasBook() {
      return this.$store.state.hasBook;
    },
    otherBuyList: function otherBuyList() {
      return ((this.buyList || []).filter(function (item) {
        return !item.bBuyForYourself || item.iTicketNum > 1;
      }) || []).map(function (item) {
        return item.bBuyForYourself ? _objectSpread(_objectSpread({}, item), {}, {
          iTicketNum: item.iTicketNum - 1,
          iHasGotNum: item.iHasGotNum - 1,
          list: (item.list || []).slice(1) // 去掉自己的

        }) : _objectSpread(_objectSpread({}, item), {}, {
          list: item.list || []
        });
      });
    },
    // 新领取的用户
    diffUserList: function diffUserList() {
      var _this = this;

      var curOrder = this.otherBuyList[0];
      if (!curOrder) return [];

      if (!this.showHistoryTime) {
        return this.otherBuyList[0].list;
      }

      return (this.otherBuyList[0].list || []).filter(function (item) {
        return +item.vuid !== +_this.userService.vuid && item.time * 1000 > _this.showHistoryTime;
      }) || [];
    }
  },
  watch: {
    diffUserList: function diffUserList(val) {
      if (val && val.length) {
        Storage.set(KEY, Date.now());
        this.showHistoryTime = Date.now();
        this.eventBus.$emit('showReceive', val);
      }
    }
  },
  methods: {
    // 选择演员弹窗
    selectActor: function selectActor() {
      var k = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // 如果嵌入在直播页，则直接跳转
      if (this.page === 'live') {
        this.openUrl(setUrlParam('page', 'role', window.location.href));
        return;
      }

      this.actorIndex = k;
    },
    // 预约首映
    bookAct: function bookAct() {
      var _arguments = arguments,
          _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var showToast;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                showToast = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : true;

                if (_this2.loginService.isLogin) {
                  _context.next = 4;
                  break;
                }

                _this2.loginService.openLogin();

                return _context.abrupt("return");

              case 4:
                if (!_this2.hasBook) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return");

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return MagicService.bookAct();

              case 9:
                _this2.refreshBookState();

                if (showToast) {
                  _this2.toast('已预约，关注【腾讯视频VIP】公众号，开播前提醒你哟');
                }

                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](6);
                console.error(_context.t0);

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[6, 13]]);
      }))();
    },
    // 刷新用户预约状态
    refreshBookState: function refreshBookState() {
      return this.$store.dispatch('hasBookAct');
    }
  }
};